import { Controller } from 'stimulus'

// Live clock for the entrance kiosk. Renders the device's local date/time and
// keeps it updated, so the page stays accurate while the kiosk is left open.
// No external dependencies — uses the platform Intl/Date APIs.

const REFRESH_INTERVAL = 30000

export default class ClockController extends Controller {
  static targets = ['date', 'time', 'meridiem']

  connect() {
    this.render()
    this.interval = setInterval(() => this.render(), REFRESH_INTERVAL)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    const now = new Date()
    const locale = this.data.get('locale') || undefined

    if (this.hasDateTarget) {
      this.dateTarget.textContent = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }).format(now)
    }

    let hours = now.getHours()
    const minutes = now.getMinutes().toString().padStart(2, '0')
    const meridiem = hours >= 12 ? 'pm' : 'am'
    hours %= 12
    if (hours === 0) {
      hours = 12
    }

    if (this.hasTimeTarget) {
      this.timeTarget.textContent = `${hours}:${minutes}`
    }
    if (this.hasMeridiemTarget) {
      this.meridiemTarget.textContent = meridiem
    }
  }
}
